<div class="container">
  <img
    src="assets/images/gif/404.gif"
    alt="404 Page Not Found Error"
    class="rounded" />
</div>
